module.exports = __webpack_public_path__ + "static/media/button-google-play.b339e82b.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/assets/button-google-play.png
// module id = 1005
// module chunks = 0